
<div class="header-toolbar">
  <h1>Utilisateurs</h1>
</div>

<!-- Toolbar -->
<div class="main btn-toolbar">

  <div class="btn-group">    
    <div class="content">
      
      <a class="btn" [routerLink]="'/settings/users/new'">
        <t-icon name="add"></t-icon>
        <span class="text">Ajouter</span>
      </a>

    </div>
  </div>

</div>
<!-- /Toolbar -->

<table>

  <thead>
    <tr>
      <th>Nom d'utilisateur</th>
      <th>Prènom</th>
      <th>Nom</th>
      <th>Date d'ajout</th>
      <th>Fuseau horaire</th>
      <th>Administrateur</th>
      <th style="width: 100px;"></th>
    </tr>
  </thead>

  <tbody *ngIf="users && users.length > 0">
    <tr *ngFor="let user of users" (click)="edit(user, $event)">
      <td name="Nom d'utilisateur">{{ user.username }}</td>
      <td name="Prènom">{{ user.firstname }}</td>
      <td name="Nom">{{ user.lastname }}</td>
      <td name="Date d'ajout">{{ user.created_at | tzdate:'short' }}</td>
      <td name="Fuseau horaire">{{ user.timezone }}</td>
      <td name="Administrateur">{{ user.is_admin | yesno }}</td>
      <td style="width: 100px;" class="actions">
        <a class="action-btn" title="Modifer" [routerLink]="['/settings/users', user.id]">
          <t-icon name="mode_edit"></t-icon>
        </a>
        <a class="action-btn" title="Supprimer" (click)="delete(user)">
          <t-icon name="delete"></t-icon>
        </a>
      </td>
    </tr>
  </tbody>

  <tbody *ngIf="!users || users.length == 0">
    <tr>
      <td class="text-center" colspan="7">
        <ng-container *ngIf="users && users.length == 0">
          Aucun utilisateur n'a été trouvé
        </ng-container>
        <ng-container *ngIf="!users">
          Chargement...
        </ng-container>
      </td>
    </tr>
  </tbody>

</table>

<div class="pagination" *ngIf="users">
  <button class="btn btn-gray" (click)="fetchMore()" *ngIf="users.length < usersCount">
    <t-icon name="arrow_downward"></t-icon>
    <span class="text">Afficher plus</span>
  </button>
  <div class="page-number">
    {{ users.length }} / {{ usersCount }}
  </div>
</div>